import React from 'react';
import './PrescriptionHelp.scss';

const PrescriptionHelp = props => {
  const { addToCart, productId, dataLocale } = props;
  const {
    EMAIL_PRESCRIPTION,
    I_WILL_EMAIL_MY_PRESCRIPTION,
    SUPPORT_EMAIL,
    CALL_ME,
    I_WANT_AN_OPTICAL_SPECIALIST,
    SAVE_AND_CONTINUE,
  } = dataLocale;
  return (
    <form className="clPrescHelpTab" onSubmit={ev => addToCart(ev)}>
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="col-lg-2 col-md-2 col-sm-2" />
        <div className="col-lg-2 col-md-2 col-sm-3 padding-t10 padding-b10 prescription-panel panel-icon">
          <span className="email-icon fa fa-envelope"></span>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 padding-t10 padding-b10 prescription-panel">
          <div className="login-step-panel prescription-help">
            <label>
              <input defaultChecked name={EMAIL_PRESCRIPTION} type="radio" />
              <span className="login-input" />
              <span>{EMAIL_PRESCRIPTION}</span>
              <div className="email-support">
                <span>
                  {I_WILL_EMAIL_MY_PRESCRIPTION} &nbsp;
                  <a href="mailto:support@lenskart.com" target="_top">
                    {SUPPORT_EMAIL}
                  </a>
                </span>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="col-lg-2 col-md-2 col-sm-2" />
        <div className="col-lg-2 col-md-2 col-sm-3 padding-t10 padding-b10 prescription-panel panel-icon">
          <span className="phone-icon fa fa-phone"></span>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-6 padding-t10 padding-b10 prescription-panel">
          <div className="login-step-panel prescription-help">
            <label>
              <input name="Email Prescription" type="radio" />
              <span className="login-input" />
              <span>{CALL_ME}</span>
              <div className="email-support">{I_WANT_AN_OPTICAL_SPECIALIST}</div>
            </label>
          </div>
        </div>
      </div>
      <button
        className="submit-btn submit-btn pull-right margin-r10 margin-b10"
        type="submit"
        unbxdattr="AddToCart"
        unbxdparam_sku={productId}
      >
        {SAVE_AND_CONTINUE}
      </button>
    </form>
  );
};

export default PrescriptionHelp;
